export default __webpack_public_path__ + "static/media/home-bg-3.cb254efe.png";